
import React from 'react';
import Dashboard from '@/pages/Dashboard/Dashboard';

const Home = () => {
  return <Dashboard />;
};

export default Home;
